import React, { useState, useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
	Alert,
} from 'reactstrap';


import { setRequireCloseModal } from '../../../../slices/fuelTank/reducer';

import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { deleteFuelTank } from '../../../../slices/fuelTank/thunk';

const DeleteFuelTankModal = ({ dataFuelTank, isOpen, handlerToggleModal }) => {
	const dispatch = useDispatch();

	const selectorSensor = createSelector(
		state => state.FuelTank,
		holding => ({
			isDeleting: holding.isDeleting,
			isDeleted: holding.isDeleted,
			isDeleteError: holding.isDeleteError,
			isLoadingList: holding.isLoadingList,
			requireCloseModal: holding.requireCloseModal,
		})
	);

	const { isDeleting, requireCloseModal } = useSelector(selectorSensor);

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handlerToggleModal();
			}
		}
	}, [requireCloseModal]);

	function handlerDelete() {
		dispatch(deleteFuelTank(dataFuelTank));
	}

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>
							¡Estás a punto de eliminar un Estanque de Combustible!
						</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en
							confirmar.
						</p>
						<p className='small'>
							Estanque de Combustible: {dataFuelTank !== null ? dataFuelTank.name : ''}
						</p>
						<div className='hstack gap-2 justify-content-center'>
							<Button className='btn-danger btn-label' onClick={() => handlerToggleModal()}><i className='icon-x label-icon'></i> Cancelar</Button>
							<button className='btn btn-label btn-primary' onClick={() => handlerDelete()} disabled={isDeleting}>{isDeleting ? (<i className='label-icon'><Spinner size='sm' /></i>) : <i className={`${Icons.check2} label-icon`}></i>} Confirmar</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeleteFuelTankModal;
